import * as React from "react";
import { Form, Field, FormElement, FieldWrapper } from "@progress/kendo-react-form";
import FormDropDown from "../formEditComponents/FormDropDown";
import {isNumeric} from "@progress/kendo-data-query/dist/npm/utils";
import FormTextBoxField from "../formEditComponents/FormTextBoxField";
import FormTextAreaField from "../formEditComponents/FormTextAreaField";
import FormNumBoxField from "../formEditComponents/FormNumBoxField";
import FormDateField from "../formEditComponents/FormDateField";
import {Button} from "@progress/kendo-react-buttons";
import useOwnRightsStore from "../../stores/OwnRightsStore";
import useFetch from "../../tools/UseFetch";
import config from "../../config/config.json";

const minValueValidator = value => value >= 0 ? "" : "The value must be 0 or higher";


const mandatoryFieldValidator = value => value != null ? "" : "mandatory field"


const useProjectEditor = props => (
    <FormDropDown
        {...props}
        textField={"ClientProjectName"}
    />
);


const ExpenseEdit = props => {

    const haveRight = useOwnRightsStore(state => state.haveRight)
    const { data:actual_user, isPending:actual_user_isPending, error:actual_user_error} = useFetch(config.API_URL + 'user/get_own_user', 1)


    const {
        cancelEdit,
        onSubmit,
        item,
        projects,
        authors,
        expenseTypes,
        currencies,
        ...other
    } = props;

    // item.UnitID = units.find((c) => c.ID === item.UnitID)
    // item.PartnerID = partners.find((c) => c.ID === item.PartnerID)


    const comparisonDate = new Date().getDate() > 5 ? new Date(new Date().getFullYear(), new Date().getMonth(), 1) : new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
    // const haveRight = useOwnRightsStore(state => state.haveRight)

    const unlockedDateFieldValidator = value => {
        if (value != null) {

            if (value >= comparisonDate) {
                return "";
            } else {
                return "Timesheet for this date is locked";
            }

        } else {
            return "mandatory field";
        }
    }

    const convertDateToUTC = (date) => {

        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();

        const utcDate = new Date(Date.UTC(year, month, day));

        return utcDate;
    };

    const handleSubmit = dataItem => {
         // debugger
        // dataItem.TimeSpentOut = dataItem.TimeSpentIn
        dataItem.Date = convertDateToUTC(dataItem.Date)
        if (!isNumeric(dataItem.ProjectID)) dataItem.ProjectID = dataItem.ProjectID.ID
        if (!isNumeric(dataItem.AuthorID)) dataItem.AuthorID = dataItem.AuthorID.ID
        if (!isNumeric(dataItem.ExpenseTypeID)) dataItem.ExpenseTypeID = dataItem.ExpenseTypeID.ID
        if (!isNumeric(dataItem.CurrencyID)) dataItem.CurrencyID = dataItem.CurrencyID.ID
        onSubmit(dataItem)
    }

    var locked = false
    var title = ``
    if (item.ID === null) {
        title = "Copy Expense"
    }
    else if (item.ID === undefined) {
        title = "Create new Expense"
    }
    else {
        // console.log("a2", item.AuthorID, actual_user.ID, haveRight("TMS_Fill_For_Others"))
        title = `Edit TMS: ${item.ID}`
        if ((item.Date < comparisonDate) || (item.AuthorID !== actual_user?.ID && !haveRight("TMS_Fill_For_Others"))) {
            title += ` - LOCKED`
            locked = true
        }
    }


    // const { data:partners, isPending, error} = useFetch(config.API_URL + 'partner/', 1)

    return (

        <div className="edit-form-outter">
            <Form initialValues={item} onSubmit={handleSubmit} render={renderProps =>

            // <Window title={title} onClose={cancelEdit}
            //         initialHeight={1000}
            //         initialWidth={600}
            //         modal={true}
            // >

            <>
                <div className="editForm">

                    <FormElement horizontal={false}>

                        {projects && <FieldWrapper><Field disabled={true} name={"ProjectID"} label={"Project"} textField={"Name"} dataItemKey={"id"} component={useProjectEditor} listData={projects} /></FieldWrapper>}
                        {authors && <FieldWrapper><Field disabled={true} name={"AuthorID"} label={"Autor"} textField={"Name"} dataItemKey={"id"} component={FormDropDown} listData={authors} validator={mandatoryFieldValidator} /></FieldWrapper>}



                        {/*<FieldWrapper><Field name={"Code"} component={FormTextBoxField}  label={"Code"} /></FieldWrapper>*/}
                        {/*<FieldWrapper><Field name={"Category"} component={FormTextBoxField}  label={"Category"} /></FieldWrapper>*/}

                        <FieldWrapper><Field name={"Date"} component={FormDateField}  label={"Date"} validator={mandatoryFieldValidator} /></FieldWrapper>

                        {expenseTypes && <FieldWrapper><Field name={"ExpenseTypeID"} label={"Expense Type"} textField={"Name"} dataItemKey={"id"} component={FormDropDown} listData={expenseTypes} validator={mandatoryFieldValidator} /></FieldWrapper>}

                        <FieldWrapper><Field name={"Price"} component={FormNumBoxField}  label={"Cena"} /></FieldWrapper>
                        {/*<FieldWrapper><Field name={"TimeSpentOut"} component={FormNumBoxField}  label={"TimeSpentOut"} /></FieldWrapper>*/}
                        {currencies && <FieldWrapper><Field name={"CurrencyID"} label={"Mena"} textField={"Name"} dataItemKey={"id"} component={FormDropDown} listData={currencies} validator={mandatoryFieldValidator}/></FieldWrapper>}

                        <FieldWrapper><Field name={"Desc"} component={FormTextAreaField}  label={"Popis"} /></FieldWrapper>
                        {/*<FieldWrapper><Field name={"Tags"} component={FormTextBoxField}  label={"Tagy"} /></FieldWrapper>*/}

                        {/*<FieldWrapper><Field name={"InvoiceNum"} component={FormTextBoxField}  label={"InvoiceNum"} /></FieldWrapper>*/}

                    </FormElement>

                </div>

                <div className={"edit-form-buttons"}>
                    <Button type={"submit"} themeColor={"success"} disabled={!renderProps.allowSubmit} onClick={renderProps.onSubmit} icon="save" >
                        Update
                    </Button>
                    <Button onClick={cancelEdit} themeColor={"secondary"} icon="cancel" >
                        Cancel
                    </Button>
                </div>

                </>

                } {...other} />
        </div>

    );
};
export default ExpenseEdit;